
/* injects from baggage-loader */
var Template = require('./template.js');
require('./style.scss');
var Template = require('./../../../../skins/newbettingterminal-betwym.betconstruct.com/terminal/containers/layout/template.js');

import { Component } from 'react';
import InitMixin from "../../../../dev/mixins/initMixin";
import { connect } from 'react-redux';
import Helpers from "../../../helpers/helperFunctions";
import { UIMixin } from "../../../mixins/uiMixin";
import Config from "../../../config/main";
import PropTypes from "prop-types";
import { createSelector } from "reselect";
import {UpperScreen} from "../../../actions/terminal";
import { broadcast, broadcastChannels } from '../../../helpers/broadcast';
import { getNetworkTime } from '../../../helpers/networkTime';

class Layout extends Component {
    constructor (props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
    }

    handleClick () {
        Helpers.hasClassName(".main-wrapper", "regionOpened") && Helpers.replaceClassName(".main-wrapper", "regionOpened", "regionClosed");
        Helpers.hasClassName(".main-wrapper", "betslip") && Helpers.removeClassName(".main-wrapper", "betslip");
    }

    UNSAFE_componentWillReceiveProps (nextProps) {
        if (nextProps.location.pathname === "/virtualGames") {
            return;
        }
        if (Config.main.upperScreenDefaultIframe) {
            Helpers.isSplitScreenAvailable()
                ? broadcast.dispatchEvent(new CustomEvent(broadcastChannels.SplitScreenChange, {
                    detail: { command: 'Video', id: 111, url: Config.main.upperScreenDefaultIframe, providerId: 21 }
                })) : nextProps.dispatch(UpperScreen({type: "Video", id: 111, videoURL: Config.main.upperScreenDefaultIframe, tv_type: 21}));
        } else {
            Helpers.isSplitScreenAvailable()
                ? broadcast.dispatchEvent(new CustomEvent(broadcastChannels.SplitScreenChange, {
                    detail: { command: 'Default', id: 0, url: "", providerId: 0 }
                })) : nextProps.dispatch(UpperScreen({type: "Default", id: 0, videoURL: "", tv_type: 0}));
        }
    }

    render () {
        return Template.default.apply(this); //eslint-disable-line no-undef
    }
}

Layout.propTypes = {
    uiClose: PropTypes.func,
    data: PropTypes.object,
    location: PropTypes.object
};

const mapStateToProps = () => {
    return createSelector(
        [
            state => JSON.stringify((() => {
                return {
                    isAsian: state.terminal.isAsian,
                    showKeyboard: state.terminal.showKeyboard
                };
            })())
        ],
        (data) => {
            return {
                data: JSON.parse(data)
            };
        });
};

export default connect(mapStateToProps)(InitMixin({Component: UIMixin({Component: Layout})}));